module.exports = __webpack_public_path__ + "static/img/day_bg.737cb54f.png";